export default __webpack_public_path__ + "static/media/promo-spectrespecs_04.81c2fa7e.jpg";